import { quickSteps } from '@/mocks/homeData';
import SectionHeading from './SectionHeading';

export default function QuickStart() {
  return (
    <section id="quickstart" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <SectionHeading
            eyebrow="快速上手 · 三步走"
            title="黑料导航怎么用，跟着这三步就行"
            desc="不用研究复杂设置，按顺序操作一遍，大多数人三分钟内就能摸清黑料导航的使用方式。"
          />
          <div className="flex items-center gap-3 text-sm text-foreground-600 bg-background-100 rounded-lg px-4 py-3 border border-background-200">
            <i className="ri-time-line text-primary-600 text-xl"></i>
            <span>平均上手时间 <strong className="text-foreground-950">约 3 分钟</strong></span>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {quickSteps.map((step) => (
            <article
              key={step.id}
              className="relative flex flex-col bg-background-100 border border-background-200 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-colors"
            >
              <span className="absolute top-5 right-5 font-heading text-4xl text-background-300">{step.no}</span>
              <span className="w-12 h-12 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${step.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg md:text-xl text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{step.desc}</p>
              <ul className="mt-4 pt-4 border-t border-background-200 space-y-2">
                {step.points.map((point) => (
                  <li key={point} className="flex items-center gap-2 text-xs md:text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-fill text-accent-600"></i>
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}